import { JSX } from "react";
import { useTranslation } from "react-i18next";

import { MovieOrderModel } from "../../../api/user/user.types";

const OrderMovieList = ({ order }: { order: MovieOrderModel }): JSX.Element => {
  const { t } = useTranslation();

  const date = new Date(order.updated_at);

  const formattedDate = date.toLocaleDateString("ru", {
    day: "2-digit",
    month: "2-digit",
    year: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });

  return (
    <div className="rounded-2xl max-sm:bg-surface-bright max-sm:p-4">
      <table className={"w-full"}>
        <tbody className="divide-outline max-sm:divide-y">
          <tr>
            <th className={"text-nowrap py-2 text-start font-normal text-[#7B7D88]"}>{t("Orders.date")}</th>
            <td className={"pl-4"}>{formattedDate}</td>
          </tr>
          <tr>
            <th className={"text-nowrap py-2 text-start font-normal text-[#7B7D88]"}>{t("General.name")}</th>
            <td className={"pl-4"}>{order.content_name}</td>
          </tr>
          <tr>
            <th className={"text-nowrap py-2 text-start font-normal text-[#7B7D88]"}>{t("General.description")}</th>
            <td className={"pl-4"}>{order.content_description}</td>
          </tr>
          <tr>
            <th className={"text-nowrap py-2 text-start font-normal text-[#7B7D88]"}>{t("General.status")}</th>
            <td className={"pl-4"}>{t(`OrderStatus.${order.status}`)}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default OrderMovieList;
